module.exports = __webpack_public_path__ + "media/assets/images/conference_room_forms/banquet-form-d3a06b41ade3932ab7f0a967ffbecab3.gif";